
export const cancelRemovingFunction = (currentId, artificialId, fetchUrl, currentAuthor) => {
    // const cancelBlock = document.getElementById(artificialId).childNodes[2];
    // const cancelBlockDelete = document.getElementById(artificialId).childNodes[0];
    // const parentString = document.getElementById(artificialId).parentNode.parentElement;
    // cancelBlock.style.display = 'none';
    // parentString.classList.remove('admin__deleted')
    // cancelBlockDelete.style.display = 'block';
    fetch(`${process.env.REACT_APP_API_URL}/${fetchUrl}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({id: Number(currentId), changingAuthor: Number(currentAuthor.id)}),
    }).then(result => {
        if(result.status !== 200) {
            console.log(result)
        }
    })
}